
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class QualityInspectionItemsDialog extends Serenity.EntityDialog<QualityInspectionItemsRow, any> {
        protected getFormKey() { return QualityInspectionItemsForm.formKey; }
        protected getIdProperty() { return QualityInspectionItemsRow.idProperty; }
        protected getLocalTextPrefix() { return QualityInspectionItemsRow.localTextPrefix; }
        protected getNameProperty() { return QualityInspectionItemsRow.nameProperty; }
        protected getService() { return QualityInspectionItemsService.baseUrl; }
        protected getDeletePermission() { return QualityInspectionItemsRow.deletePermission; }
        protected getInsertPermission() { return QualityInspectionItemsRow.insertPermission; }
        protected getUpdatePermission() { return QualityInspectionItemsRow.updatePermission; }

        protected form = new QualityInspectionItemsForm(this.idPrefix);

    }
}